<template>
  <div class="products">
    <!-- 面包屑导航-->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>会员中心</el-breadcrumb-item>
      <el-breadcrumb-item>产品管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 内容 -->
    <el-card class="main">
      <!-- 头部查询 -->
      <div slot="header" class="clearfix">
        <el-input placeholder="请输入品名" v-model="inputVal" clearable></el-input>
        <el-input placeholder="请输入ASIN" disabled clearable></el-input>
        <el-button type="primary" size="small" @click="queryOrder">查询</el-button>
        <el-button type="primary" @click="addSup">添加产品</el-button>
      </div>
      <!-- 表格 -->
      <!-- 信息列表 -->
      <el-table :data="productData" style="width: 100%">
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleEdit(scope.$index,scope.row)">编辑</el-button>
            <el-button size="mini" type="text" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
        <el-table-column label="产品图片">
          
          <template slot-scope="scope">
            <el-image
              style="max-width: 100px;"
              :src="scope.row.picUrl"
              fit="cover">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </template>
        
        </el-table-column>
        <el-table-column label="中文名称" prop="name">
          <template slot-scope="scope">
            <span> {{scope.row.name}}</span><br>
            <span> {{scope.row.ename}}</span>
          </template>
        </el-table-column>
        <el-table-column label="报关编码" prop="hscode"></el-table-column>
        <el-table-column label="清关编码" prop="gwcode"></el-table-column>
        <el-table-column label="税率" prop="taxRate"></el-table-column>
        <el-table-column label="材质" prop="material"></el-table-column>
        <el-table-column label="用途" prop="purpose"></el-table-column>
        <el-table-column label="型号" prop="model"></el-table-column>
        <el-table-column label="品牌" prop="brand">
          <template slot-scope="scope">
            <span> {{scope.row.brand}}</span><br>
            <span> {{scope.row.brandTypeTxt}}</span>
          </template>
        </el-table-column>
        <el-table-column label="尺寸" prop="size"></el-table-column>
        <!-- <el-table-column label="出口享惠" prop="exportBenefitsTxt"></el-table-column> -->
        <!-- <el-table-column label="带电带磁" prop="electrificationStateTxt"></el-table-column> -->
        <el-table-column label="链接" prop="makerAdd">
          <template slot-scope="scope">
            <span><el-link  type="primary" :href="scope.row.makerAdd " target="_blank"> {{scope.row.makerAdd}} </el-link></span>
          </template>
        </el-table-column>
        <el-table-column label="ASIN" prop="maker"></el-table-column>
        <el-table-column label="创建时间" prop="createTime">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | dateformat }}</span>
          </template>
        </el-table-column>
        

      </el-table>

      <!-- 弹出框 -->
      <el-dialog
        :title="price ? '新增产品' : '修改产品'"
        :visible.sync="dialogFormVisible"
        :before-close="closeDialog"
        :close-on-click-modal="false"
      >
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <div class="form-box">
            <el-form-item label="中文名称" prop="name">
              <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
            <el-form-item label="英文名称" prop="ename">
              <el-input v-model="ruleForm.ename"></el-input>
            </el-form-item>
            <el-form-item label="材质" prop="material">
              <el-input v-model="ruleForm.material" placeholder="中英文"></el-input>
            </el-form-item>
            <el-form-item label="用途" prop="purpose">
              <el-input v-model="ruleForm.purpose" placeholder="中英文"></el-input>
            </el-form-item>
            <el-form-item label="型号" prop="model">
              <el-input v-model="ruleForm.model"></el-input>
            </el-form-item>
            <el-form-item label="国家" prop="country">
              <!-- 国家组件 -->
              <Country :countrys="ruleForm.country" @getCty="getCountry"></Country>
            </el-form-item>
            <el-form-item label="报关编码">
              <el-input v-model="ruleForm.hscode"></el-input>
            </el-form-item>
            <el-form-item label="清关编码">
              <el-input v-model="ruleForm.gwcode"></el-input>
            </el-form-item>
            <el-form-item label="税率">
              <el-input v-model="ruleForm.taxRate"></el-input>
            </el-form-item>
            <el-form-item label="ASIN/SKU">
              <el-input v-model="ruleForm.maker"></el-input>
            </el-form-item>
          </div>
          <div class="form-box">
            <el-form-item label="品牌">
              <el-input v-model="ruleForm.brand"></el-input>
            </el-form-item>
            <el-form-item label="品牌类型" prop="brandType">
              <el-select v-model="ruleForm.brandType" clearable placeholder="请选择">
                <el-option
                  v-for="item in brandType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="出口享惠" prop="exportBenefits">
             <el-select v-model="ruleForm.exportBenefits" clearable placeholder="请选择">
                <el-option
                  v-for="item in exportBenefits"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="带电带磁" prop="electrificationState">
             <el-select v-model="ruleForm.electrificationState" clearable placeholder="请选择">
                <el-option
                  v-for="item in electrificationState"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="尺寸" >
              <el-input v-model="ruleForm.size" placeholder="长*宽*高cm"></el-input>
            </el-form-item>
            <el-form-item label="链接" >
              <el-input v-model="ruleForm.makerAdd" placeholder="销售链接"></el-input>
            </el-form-item>
            <!-- 上传地址 -->
            <el-form-item label="上传图片">
              <el-upload
                class="upload-demo"
                :action="apiAction()"
                :on-success="handSuccess"
                :on-remove="handRemove"
                :before-upload="before"
                :file-list="fileList"
                list-type="picture"
                :limit="1"
                name="upload"
                :headers="myHeaders"
              >
                <el-button size="small" type="primary">
                  点击上传
                  <i class="el-icon-upload el-icon--right"></i>
                </el-button>
              </el-upload>
            </el-form-item>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm('ruleForm')">{{price?"添 加":"修 改"}}</el-button>
        </div>
      </el-dialog>
      <!-- 分页功能 -->
      <div class="block" style="margin-top:20px">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 40,60, 80,100]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
var token = sessionStorage.getItem("token"); // 要保证取到
//引入api
import httpApi from "@/http/api"
//引入组件
import Country from "@/components/Country";
export default {
  components: {
    Country
  },
  data() {
    return {
      myHeaders: { token: token },
      productData: [], //产品列表
      dialogFormVisible: false, //弹出框
      price: true, //新增修改
      fileList: [], //上传图片列表
      inputVal: "",
      currentPage: 1, //分页初始页
      pagesize: 20, //分页每页数据
      total: 0, //分页总数
      index: 0, //下标
      ruleForm: {
        // 弹出框数据
        name: "", //中文
        ename: "", //英文
        country: "", //国家
        hscode: "", //报关编码
        gwcode: "", //清关编码
        taxRate: "", //税率
        material: "", //材质
        model: "", //型号
        purpose: "", //用途
        brand: "", //品牌
        picName: "", //图片名字
        picUrl: "", //图片路径
        id: "",
        brandType: "", //品牌类型
        exportBenefits: "", //出口享惠
        electrificationState: "", //带电带磁
        brandTypeTxt: "",
        exportBenefitsTxt: "",
        electrificationStateTxt: "",
        creatTime:"",
        maker:"",
        makerAdd:"",
      },
      // 正则验证
      rules: {
        name: [{ required: true, message: "请输入中文名称", trigger: "blur" }],
        ename: [{ required: true, message: "请输入英文名称", trigger: "blur" }],
        material: [{ required: true, message: "请输入材质", trigger: "blur" }],
        purpose: [{ required: true, message: "请输入用途", trigger: "blur" }],

      },
      brandType: [
        { label: "无品牌", value: "0" },
        { label: "境内自主品牌", value: "1" },
        { label: "境内收购品牌", value: "2" },
        { label: "境外品牌(贴牌生产)", value: "3" },
        { label: "境外品牌(其他)", value: "4" }
      ],
      exportBenefits: [
        { label: "出口货物在最终目的国（地区）不享受优惠关税", value: "0" },
        { label: "出口货物在最终目的国（地区）享受优惠关税", value: "1" },
        { label: "出口货物不能确定在最终目的国（地区）享受优惠关税",value: "2"
        }
      ],
      electrificationState: [
        { label: "否", value: "0" },
        { label: "只带电", value: "1" },
        { label: "只带磁", value: "2" },
        { label: "带电带磁", value: "3" }
      ]
    };
  },
  methods: {
    apiAction(){
      return this.mApi + "/file/upload"
    },
    //新增产品
    addSup() {
      this.dialogFormVisible = true;
      //新增操作
      this.price = true;
      //数据清理
      this.fileList = [];
      for (let i in this.ruleForm) {
        this.ruleForm[i] = "";
      }
    },
    closeDialog() {
      this.$refs.ruleForm.clearValidate();
      this.dialogFormVisible = false;
    },
    // 新增提交
    submitForm(formName) {
      let that = this;
      that.$refs[formName].validate(valid => {
        if (valid) {
          // if (that.ruleForm.picUrl !== "") {
          //判断是修改还是新增
          if (that.price) {
            httpApi
              .addProduct({
                brand: that.ruleForm.brand,
                country: that.ruleForm.country,
                ename: that.ruleForm.ename,
                hscode: that.ruleForm.hscode,
                gwcode: that.ruleForm.gwcode,
                taxRate: that.ruleForm.taxRate,
                maker: that.ruleForm.maker,
                makerAdd: that.ruleForm.makerAdd,
                material: that.ruleForm.material,
                name: that.ruleForm.name,
                picName: that.ruleForm.picName,
                picUrl: that.ruleForm.picUrl,
                purpose: that.ruleForm.purpose,
                model: that.ruleForm.model,
                brandType: that.ruleForm.brandType,
                exportBenefits: that.ruleForm.exportBenefits,
                electrificationState : that.ruleForm.electrificationState,
                size: that.ruleForm.size,
              })
              .then(res => {
                if (res.data.code == "ok") {
                  //添加成功
                  that.$message.success("添加成功！");
                  that.dialogFormVisible = false;
                  that.productData.unshift(
                    JSON.parse(JSON.stringify(that.ruleForm))
                  );
                  // 数据清理
                  that.$refs[formName].resetFields();
                  that.queryProduct();
                } else {
                  that.$message.error(res.data.message);
                }
              });
          } else {
            //修改
            httpApi
              .updateProdct({
                brand: that.ruleForm.brand,
                country: that.ruleForm.country,
                ename: that.ruleForm.ename,
                hscode: that.ruleForm.hscode,
                gwcode: that.ruleForm.gwcode,
                taxRate: that.ruleForm.taxRate,
                maker: that.ruleForm.maker,
                makerAdd: that.ruleForm.makerAdd,
                material: that.ruleForm.material,
                name: that.ruleForm.name,
                picName: that.ruleForm.picName,
                picUrl: that.ruleForm.picUrl,
                purpose: that.ruleForm.purpose,
                id: that.ruleForm.id,
                model: that.ruleForm.model,
                brandType: that.ruleForm.brandType,
                exportBenefits: that.ruleForm.exportBenefits,
                electrificationState : that.ruleForm.electrificationState,
                size: that.ruleForm.size,
                
              })
              .then(res => {
                if (res.data.code == "ok") {
                  //修改成功
                  that.$message.success("修改成功！");
                  that.dialogFormVisible = false;
                  that.productData.splice(
                    that.index,
                    1,
                    JSON.parse(JSON.stringify(that.ruleForm))
                  );
                } else {
                  that.$message.error(res.data.message);
                }
              });
          }
          // } else {
          //   that.$message.error("请上传产品图片");
          // }
        } else {
          return false;
        }
      });
    },
    // 国家选择
    getCountry(e) {
      this.ruleForm.country = e;
    },
    //编辑
    handleEdit(index, row) {
      let that = this;
      that.dialogFormVisible = true;
      that.price = false;
      that.ruleForm = {
        brand: row.brand,
        country: row.country,
        ename: row.ename,
        hscode: row.hscode,
        gwcode: row.gwcode,
        taxRate: row.taxRate,
        maker: row.maker,
        makerAdd: row.makerAdd,
        material: row.material,
        materialRate: row.materialRate,
        name: row.name,
        price: row.price,
        purpose: row.purpose,
        picName: row.picName,
        picUrl: row.picUrl,
        id: row.id,
        model: row.model,
        brandType: row.brandType,
        exportBenefits: row.exportBenefits,
        electrificationState : row.electrificationState,
        size : row.size,
      };
      if(row.picName == "" && row.picUrl == ""){
        that.fileList = [];
      }else{
        that.fileList = [{ name: row.picName, url: row.picUrl }];
      }
      that.index = index;
    },
    //删除
    handleDelete(index, row) {
      let that = this;
      let rowId = row.id;
      that
        .$confirm("此操作将永久删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          httpApi
            .delProduct({}, { params: { id: rowId } })
            .then(res => {
              //判断接收的响应码
              if (res.data.code == "ok") {
                that.$message.success("删除成功!");
                // 在数组里面删除数据
                that.productData.splice(index, 1);
                that.queryProduct();
              } else {
                that.$message.error(res.data.message);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 上传图片成功
    handSuccess(file, fileList) {
      this.ruleForm.picName = file.data.filename;
      this.ruleForm.picUrl = file.data.url;
    },
    before(file){
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('只能上传jpg或png格式的图片');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    //移除图片
    handRemove() {
      this.ruleForm.picName = "";
      this.ruleForm.picUrl = "";
    },
    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange: function(size) {
      this.pagesize = size;
      this.currentPage = 1;
      //每页下拉显示数据
      this.queryProduct();
    },
    handleCurrentChange: function(currentPage) {
      this.currentPage = currentPage;
      //点击第几页
      this.queryProduct();
    },
    //查询产品
    queryProduct() {
      let that = this;
      httpApi
        .queryProduct( {
          params: {
            page: that.currentPage,
            rows: that.pagesize,
            name: that.inputVal
          }
        })
        .then(res => {
          if (res.data.code == "ok") {
            that.productData = res.data.data.rows;
            that.total = res.data.data.total;
          } else {
            that.$message.error(res.data.message);
          }
        });
    },
    queryOrder() {
      this.queryProduct();
    },
    //查询产品参数
    listPro() {
      let that = this;
      httpApi.queryProduct().then();
    }
  },
  created() {
    this.queryProduct();
    this.ruleForm.country = "美国";
  },
  watch: {
    productData(v){
      for (const i in v) {
        let numBT = v[i].brandType;//品牌类型解析
        switch(numBT){
          case "0":
            v[i].brandTypeTxt = "无品牌"
            break;
          case "1":
            v[i].brandTypeTxt = "境内自主品牌"
            break;
          case "2":
            v[i].brandTypeTxt = "境内收购品牌"
            break;
          case "3":
            v[i].brandTypeTxt = "境外品牌（贴牌生产）"
            break;
          case "4":
            v[i].brandTypeTxt = "境外品牌（其他）"
            break;
        }
        let numEBF = v[i].exportBenefits;//出口享惠解析
        switch(numEBF){
          case "0":
            v[i].exportBenefitsTxt = "出口货物在最终目的国（地区）不享受优惠关税"
            break;
          case "1":
            v[i].exportBenefitsTxt = "出口货物在最终目的国（地区）享受优惠关税"
            break;
          case "2":
            v[i].exportBenefitsTxt = "出口货物不能确定在最终目的国（地区）享受优惠关税"
            break;
        }
        let numES = v[i].electrificationState;//带电带磁解析
        switch(numES){
          case "0":
            v[i].electrificationStateTxt = "否"
            break;
          case "1":
            v[i].electrificationStateTxt = "只带电"
            break;
          case "2":
            v[i].electrificationStateTxt = "只带磁"
            break;
          case "3":
            v[i].electrificationStateTxt = "带电带磁"
            break;
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  .el-dialog__body {
    padding-bottom: 0px;
    .el-form {
      display: flex;
      .form-box {
        width: 50%;
      }
    }
    /deep/.el-input,
    .el-textarea {
      float: left;
      width: 80%;
      .el-textarea__inner {
        height: 80px;
      }
    }
    .el-form-item__content {
      text-align: left;
      .el-select {
        position: absolute;
        width: 100%;
      }
    }
    .el-upload-list {
      width: 92%;
    }
  }
  .el-dialog__footer {
    .dialog-footer {
      margin-right: 35px;
    }
  }
}
/deep/.block {
  margin-top: 20px;
  text-align: center;
}
/deep/.el-form-item__label {
  font-size: 13px;
}
.el-icon-picture-outline{
  font-size: 30px;
  margin-left: 30px;
}
</style>